import { QuickShipsActions } from "../../types";

const initialState: any = {
  loading: false,
  data: [],
  considerCurrentUnit: false,
};

function appendPayload(
  data: any,
  newItems: any,
  acceptWrongItems: boolean,
  considerCurrentUnit: boolean,
) {
  console.log("considerCurrentUnit", considerCurrentUnit);
  newItems.forEach((item: any) => {
    const row = data.find((elm: any) => elm.item_number === item.item.number);

    // Wrong Item added
    if (!row) {
      return acceptWrongItems
        ? data.push({
            item: item.item,
            wrong_item: true,
            ordered_qty: "-",
            item_number: item.item.number,
            tags: item.tags,
            read_qty:
              item.tags.reduce(
                (total: number, tag: any) =>
                  total +
                  parseInt((considerCurrentUnit && tag.current_units) || 1),
                0,
              ) || 0,
            valid: false,
          })
        : data;
    }

    if (row.tags) {
      item.tags.forEach((tag: any) => {
        if (!row.tags.find((i: any) => i.id === tag.id)) row.tags.push(tag);
      });
    } else {
      row.tags = item.tags;
    }

    row.read_qty =
      row.tags.reduce(
        (total: number, tag: any) =>
          total + parseInt((considerCurrentUnit && tag.current_units) || 1),
        0,
      ) || 0;
    row.valid = row.ordered_qty === row.read_qty;
  });

  return [...data];
}

function overrideItem(
  data: any,
  item: any,
  override: boolean,
  override_reason: string,
) {
  const row = data.find((elm: any) => elm.item_number === item.item_number);
  row.override = override;
  row.override_reason = override_reason;

  return [...data];
}

export default function (state: any = initialState, action: any) {
  switch (action.type) {
    case QuickShipsActions.StoreInitialState:
      return {
        ...state,
        considerCurrentUnit: action.payload.considerCurrentUnit,
        data: action.payload.items.map((i: any) => ({
          ...i,
          valid: i.shipped_qty === i.ordered_qty || i.override,
          read_qty: i.shipped_qty || 0,
        })),
      };

    case QuickShipsActions.ItemAppend:
      return {
        ...state,
        data: appendPayload(
          state.data,
          action.items,
          action.acceptWrongItems,
          state.considerCurrentUnit,
        ),
      };

    case QuickShipsActions.ItemOverride:
      return {
        ...state,
        data: overrideItem(
          state.data,
          action.item,
          action.override,
          action.override_reason,
        ),
      };

    case QuickShipsActions.ItemRemove:
      return {
        ...state,
        data: state.data.filter(
          (i: any) => i.item_number !== action.item.item_number,
        ),
      };

    default:
      return state;
  }
}
